let isOnline = true;

// Listen for connection status changes from main process
window.electron.on('connection-status-changed', (status) => {
    isOnline = status;
    updateFormStates();
});

// Function to update form states based on connection status
function updateFormStates() {
    // Handle Filament form buttons
    const forms = document.querySelectorAll('form');
    forms.forEach(form => {
        const submitButton = form.querySelector('button[type="submit"]');
        if (submitButton) {
            submitButton.disabled = !isOnline;
            if (!isOnline) {
                submitButton.title = 'Cannot submit while offline';
            } else {
                submitButton.title = '';
            }
        }
    });

    // Handle Filament table actions
    const actionButtons = document.querySelectorAll('[data-filament-action]');
    actionButtons.forEach(button => {
        button.disabled = !isOnline;
        if (!isOnline) {
            button.title = 'Cannot perform action while offline';
        } else {
            button.title = '';
        }
    });
}

// Function to show offline message using Filament's notification system
function showOfflineMessage() {
    // Use Filament's notification system if available
    if (window.$wire) {
        window.$wire.dispatch('notify', {
            title: 'No Internet Connection',
            message: 'Please check your connection and try again.',
            icon: 'heroicon-o-wifi',
            iconColor: 'danger',
            duration: 5000
        });
    } else {
        // Fallback to Filament's Alpine.js notification if $wire is not available
        const notification = {
            title: 'No Internet Connection',
            message: 'Please check your connection and try again.',
            icon: 'heroicon-o-wifi',
            iconColor: 'danger',
            duration: 5000
        };

        // Dispatch to Filament's notification system
        window.dispatchEvent(new CustomEvent('filament-notify', {
            detail: notification
        }));
    }
}

// Intercept Livewire form submissions and responses
document.addEventListener('livewire:init', () => {
    Livewire.hook('request', ({ uri, options, payload, respond, succeed, fail }) => {
        if (!isOnline) {
            // Prevent the request if offline
            respond({
                status: 0,
                content: 'No internet connection',
                preventDefault: true
            });
            showOfflineMessage();
            return;
        }
        
        // Continue with the request if online
        succeed(({ status, json }) => {
            return { status, json };
        });

        fail(({ status, content, preventDefault }) => {
            // Check if the error is a database connection error
            if (content && (
                content.includes('SQLSTATE[HY000]') || 
                content.includes('getaddrinfo failed') ||
                content.includes('Temporary failure in name resolution')
            )) {
                showOfflineMessage();
                return {
                    status: 0,
                    content: 'No internet connection',
                    preventDefault: true
                };
            }
            return { status, content, preventDefault };
        });
    });
});

// Update form states when the page loads
document.addEventListener('DOMContentLoaded', updateFormStates);

// Update form states when Livewire updates the DOM
document.addEventListener('livewire:navigated', updateFormStates);

// Update form states when Filament updates the DOM
document.addEventListener('filament:loaded', updateFormStates); 